module.exports = __webpack_public_path__ + "img/ewm2.9d358954.png";